module.exports = __webpack_public_path__ + "img/contagem.52482b6e.png";